import React from "react";
import { WorldMap } from "react-svg-worldmap";
import "./worldmap.scss";

const data = [
  { country: "in", value: 2, name: "India" }, 
  { country: "au", value: 2, name: "Australia" }, 
  { country: "us", value: 2, name: "USA" },
];

const stylingFunction = ({ countryCode }) => ({
  fill: countryCode === "IN" || countryCode === "AU" || countryCode === "US" ? "blue" : "#82ccdd",
  stroke: "#fff",
  strokeWidth: 0.5,
});

const SVGWorldMap = () => {
  return (
    <div className="svg-world-map-container">
      <h2 className="title">Arrow Digital Locations</h2>
      <div className="map-container">
        <WorldMap
          color="blue"
          valueSuffix="locations"
          size="responsive"
          data={data}
          styleFunction={stylingFunction}
        />
      </div>
      <div className="location-list">
        {data.map(({ name }) => (
          <span key={name} className="location-name">
            {name}
          </span>
        ))}
      </div>
    </div>
  );
};

export default SVGWorldMap;
